import React from 'react';
import { formatMoney } from '../../../../../util/numberUtils';
import { hasDiscount } from '../../../../../util/productUtils';
import TooltipMC from '../../../../components/TooltipMC';

const ProductPriceDisplay = ({ item, currency_symbol, currency_code, t }) => (
  <div className="md:tw-col-span-3 tw-text-right px-0 tw-flex tw-flex-col tw-items-end">
    <span className={`${item.wasSelected ? 'tw-text-gray-300' : 'tw-text-gray-700'}`}>
      {currency_symbol}
      {formatMoney(hasDiscount(item) ? item.discounted_price : item.price)}
      {' '}
      {currency_code}
    </span>
    {hasDiscount(item) && (
      <span className="tw-line-through tw-text-xs tw-text-gray-400 tw-flex tw-items-center tw-gap-1">
        <span>
          {currency_symbol}
          {formatMoney(item.price)}
          {' '}
          {currency_code}
        </span>
        <TooltipMC text={t('search.discounted_price')} position="bottom-end">
          <i className="mi-info-outline tw-text-xs tw-cursor-pointer" />
        </TooltipMC>
      </span>
    )}
  </div>
);

export default ProductPriceDisplay;
